import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconEditMetaData = ({ fill = '#262626', ...restProps }) => (
  <SVG viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path
      d="M8.295 4.515L8.985 5.205L2.19 12H1.5V11.31L8.295 4.515ZM10.995 0C10.8075 0 10.6125 0.075 10.47 0.2175L9.0975 1.59L11.91 4.4025L13.2825 3.03C13.575 2.7375 13.575 2.265 13.2825 1.9725L11.5275 0.2175C11.3775 0.0675 11.19 0 10.995 0ZM8.295 2.3925L0 10.6875V13.5H2.8125L11.1075 5.205L8.295 2.3925Z"
      fill={fill || '#262626'}
    />
  </SVG>
)

export default withIconStyles(IconEditMetaData)
